import React from "react";
import { Card, CardContent } from "../../ui/card";
import { useRealTimeState } from "../reducer/RealTimeContext";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  INQUIRY_STATUS,
  INQUIRY_STATUS_LABEL,
} from "../Content/CustomerInquiry/useCustomerInquiry";

const statusColorMap: Record<number, string> = {
  [INQUIRY_STATUS.PENDING]: "bg-orange-100 text-orange-700",
  [INQUIRY_STATUS.IN_PROGRESS]: "bg-blue-100 text-blue-700",
};

const Item = ({
  title,
  content,
  link,
  badge,
  navState,
}: {
  title: string;
  content: string;
  link: string;
  badge?: React.ReactNode;
  navState?: Record<string, any>;
}) => {
  const navigate = useNavigate();

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow gap-0"
      onClick={() => navigate(`/dashboard/${link}`, navState ? { state: navState } : undefined)}
    >
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-1.5">
          <div className="text-sm font-semibold">{title}</div>
          {badge}
        </div>
        <div className="text-xs text-gray-600">{content}</div>
      </CardContent>
    </Card>
  );
};

const RealTimeRequestPresenter = () => {
  const { registerUserData, requestBankingData, customerInquiryData } = useRealTimeState() as any;

  return (
    <div className="space-y-2">
      {registerUserData.map((data: any) => (
        <Item
          title="회원가입 승인신청"
          content={
            data.birthDate
              ? `${data.id}님의 회원가입승인 대기중 (생년월일: ${data.birthDate})`
              : `${data.id}님의 회원가입승인 대기중`
          }
          key={`reg-${data.id}`}
          link="registerStatus"
        />
      ))}
      {requestBankingData.map((data: any) => {
        const title =
          data.isDeposit === null
            ? "계좌번호 요청"
            : data.isDeposit
            ? "입금요청"
            : "출금요청";

        return (
          <Item
            key={`bank-${data.id}`}
            title={title}
            content={`${data.userId}님의 ${title} 대기중`}
            link="depositNWithdrawalStatus"
          />
        );
      })}
      {customerInquiryData?.map((data: any) => {
        const userId = data.userId || "Unknown";

        return (
          <Item
            key={`inq-${data.id}`}
            title="1:1 문의"
            content={`${userId}님의 문의`}
            link="customerInquiry"
            navState={{ inquiryId: data.id }}
            badge={
              <span
                className={cn(
                  "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
                  statusColorMap[data.status] || "bg-gray-100 text-gray-500"
                )}
              >
                {INQUIRY_STATUS_LABEL[data.status] || "알수없음"}
              </span>
            }
          />
        );
      })}
    </div>
  );
};

export default React.memo(RealTimeRequestPresenter);
